import type { MouseEvent } from "react";

export function SkipToContent() {
  const skipToContent = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    const main = document.getElementById("main-content");
    if (!main) return;

    if (!main.hasAttribute("tabindex")) {
      main.setAttribute("tabindex", "-1");
    }

    main.focus();
    main.scrollIntoView({ block: "start" });
  };

  return (
    <a className="skip-link" href="#main-content" onClick={skipToContent}>
      Skip to main content
    </a>
  );
}
